import { render, staticRenderFns } from "./ExtendedCollectionAnalytics.vue?vue&type=template&id=38a44696&"
import script from "./ExtendedCollectionAnalytics.vue?vue&type=script&lang=js&"
export * from "./ExtendedCollectionAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports